<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="10" lg="6">
          <v-sheet class="neu-glow with-radius fill-height" height="100%">
            <v-img
              src="/static/ob-animated-isometric/404-error-animate.svg"
              lazy-src="/static/ob-animated-isometric/404-error-animate.svg"
              height="400"
              contain
            >
            </v-img>
            <v-row justify="end" class="fill-height">
              <v-col class="text-center px-10" cols="12">
                <h3 class="mb-1">
                  {{$t(page+'.Account not found')}}
                </h3>                
              </v-col>
              <!--
              <v-col class="text-center px-10" cols="12">
                <div class="text-body-1 mb-5">
                  {{$t(page+'.That means this account is available')}}
                </div>
                <v-btn
                  color="info"
                  href="https://ibookrestaurant.com/auth/signup"
                  class="mb-5"
                  >{{$t(page+'.Make it Yours')}}!</v-btn
                >
              </v-col>
              -->
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>


<script>

export default {
  created(){
    document.title = 'iBookRestaurant | unknown';
  },
  data() 
  {
    return {
      page:'Booking'
    }
  }
};
</script>